import { MutableRefObject, RefCallback } from "react";

type ReactRef<T> = MutableRefObject<T> | RefCallback<T>;

export function mergeRefs<T>(...refs: (ReactRef<T> | null | undefined)[]): RefCallback<T> {
  return (value: T) => {
    refs.forEach((ref) => {
      if (typeof ref === "function") {
        ref(value);
      } else if (ref != null) {
        (ref as MutableRefObject<T | null>).current = value;
      }
    });
  };
}
